import { Badge, Button, Dropdown, Menu, Select, Space } from 'antd';
// import { MenuProps } from 'antd/lib';
import { useTokenContext } from 'contexts/resource/ResourceContext';
// import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import {
  //   // useSetLocale,
  //   // useGetLocale,
  useLogout,
  useTranslate,
} from '@refinedev/core';
// import LanguageLabels from 'components/header/data';
import { BellOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import routeName from 'core/common/routeName';
import { getOrganizationName } from 'pages/profile/apiCall';

// const { useBreakpoint } = Grid;

const HeaderContainerView = ({
  // saveLang,
  filterOption,
  saveOrg,
  saveProgram,
  handleToggleNotifications,
}: any) => {
  // const locale = useGetLocale();
  // const { i18n } = useTranslation();
  const t = useTranslate();
  // const currentLocale = locale();
  //  const changeLanguage = useSetLocale();
  const navigate = useNavigate();
  const {
    orgId,
    //  setCurrentLang,
    organizationList,
    userProgramList,
    programId,
    notificationMessages,
  } = useTokenContext();
  // const screens = useBreakpoint();
  const { userDetails } = useTokenContext();

  const { mutate: logout } = useLogout();
  // const menuItemsLang: MenuProps['items'] = [...(i18n.languages || [])]
  //   .sort()
  //   .map((lang: string) => ({
  //     key: lang,
  //     onClick: async () => {
  //       await setCurrentLang(lang);
  //       await changeLanguage(lang);
  //       await saveLang(lang);
  //     },

  //     label: LanguageLabels[lang] || lang,
  //   }));
  const menu = (
    <Menu>
      <Menu.Item
        key="profile"
        onClick={() => {
          navigate(routeName.profile);
        }}
      >
        {t('common.profile')}
      </Menu.Item>
      <Menu.Item
        key="logout"
        onClick={() => {
          logout();
        }}
      >
        {t('buttons.logout')}
      </Menu.Item>
    </Menu>
  );

  const handleOrgChange = (e: string) => {
    saveOrg(e);
  };

  const handleProgramChange = (e) => {
    saveProgram(e);
  };

  useEffect(() => {
    if (
      userProgramList?.length > 0 &&
      !userProgramList.some((prog) => prog.value === programId)
    ) {
      handleProgramChange(userProgramList[0].value);
    }
  }, [userProgramList]);
  return (
    <Space size={12}>
      {organizationList?.length > 1 ? (
        <Select
          className="org-select"
          style={{ width: 300 }}
          value={organizationList?.length > 0 ? orgId : undefined}
          placeholder="Select Organisation"
          onChange={(e) => handleOrgChange(e)}
          showSearch
          options={organizationList}
          optionFilterProp="children"
          filterOption={filterOption}
        />
      ) : null}
      {userProgramList?.length > 1 ? (
        <Select
          className="org-select"
          style={{ width: 300 }}
          value={userProgramList?.length > 0 ? programId : null}
          placeholder="Select Role"
          onChange={(e) => handleProgramChange(e)}
          showSearch
          options={userProgramList}
          optionFilterProp="children"
          filterOption={filterOption}
        />
      ) : null}
      {/* <Dropdown
        className="multilingual"
        menu={{
          items: menuItemsLang,
          selectedKeys: currentLocale ? [currentLocale] : [],
        }}
      >
        <a
          style={{ color: 'inherit' }}
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          <Space>
          
            <div
              style={{
                display: screens.lg ? 'block' : 'none',
              }}
            >
              {LanguageLabels[currentLocale]}
              <DownOutlined
                style={{
                  fontSize: '12px',
                  marginLeft: '6px',
                }}
              />
            </div>
          </Space>
        </a>
      </Dropdown> */}

      <div id="notifications">
        <Badge
          count={
            notificationMessages && notificationMessages?.length > 0
              ? JSON.parse(notificationMessages)?.length
              : 0
          }
        >
          <BellOutlined
            onClick={handleToggleNotifications}
            className="text-lg text-neutral-10 cursor-pointer"
          />
        </Badge>
      </div>

      <Dropdown overlay={menu} placement="bottomRight">
        <Space size="middle">
          <Button
            className="text-heading font-bold !rounded-full !bg-neutral-60"
            icon={<UserOutlined className="avatar-icon" />}
            // onClick={() => navigate(routeName.profile)}
          />
        </Space>
      </Dropdown>

      <div className="ml-md">
        <div className="font-semibold text-base text-neutral-10">{`${userDetails?.user_first_name} ${userDetails?.user_last_name}`}</div>
        <div className="text-sm text-neutral-100">
          {getOrganizationName(userDetails?.organization_id)}
        </div>
      </div>
    </Space>
  );
};

export default HeaderContainerView;
